import React from 'react';
import { ViewComponentProps, withView } from '../shared/viewcomponent';
import { SearchSection } from './searchsection';


export const UpdateSecondaryAddresseeComponent = withView((props: ViewComponentProps) => {
    let companyCode = props.getQueryParam("companyCode")
    let policyNumber = props.getQueryParam("policyNumber")

    return <>
        <SearchSection {...props} changeType={4} companyCode={companyCode} policyNumber={policyNumber} />
    </>

});
